import React from 'react';
import classnames from 'classnames';
import styles from './CreateContactModal.module.scss';
import { Link } from 'react-router-dom';
import { Contact, DataVendor } from 'v2/models';
import Avatar from 'v2/Avatar/Avatar';
import avatarPersonNoProfilePic from 'v2/images/avatarPersonNoProfilePic.png';
import { useTranslation } from 'react-i18next';
import { TranslationKeys } from 'translations';

interface ExistingContactBoxProps {
  email: string;
  contact: Contact;
  dataVendor?: DataVendor;
}

const ExistingContactBox = ({
  email,
  contact,
  dataVendor,
}: ExistingContactBoxProps) => {
  const { t } = useTranslation();

  return (
    <>
      <p
        className={classnames(styles.existingContactBoxMessage)}
        data-cy="contact:already-existing-email-box-message"
      >
        Whoops! It looks like a {t(TranslationKeys.contact_one)} with the email
        address <span>{email}</span> already exists.
      </p>
      <div
        className={classnames(styles.existingContactBox)}
        data-cy="contact:already-existing-email-box"
      >
        <Avatar
          url={contact.avatar_url || avatarPersonNoProfilePic}
          className={classnames(styles.existingContactBoxAvatar)}
        />
        <div className={classnames(styles.existingContactBoxInfo)}>
          <p className={classnames(styles.existingContactBoxName)}>
            {contact.first_name} {contact.last_name}
          </p>
          <p>{contact.title}</p>
          <p>{contact.primary_associations.email?.email || email}</p>
        </div>
        <Link
          to={{
            pathname: `/contact-details/${contact.id}/detail`,
            state: {
              counterToGoBack: -1,
              backLinkTitle: dataVendor?.name || 'Back',
            },
          }}
          className={classnames(styles.contactName)}
        >
          View profile
        </Link>
      </div>
    </>
  );
};

export default ExistingContactBox;
